import Vue from 'vue'
import Router from 'vue-router'
import ElementUI from 'element-ui'

import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'

import IndexPage from '@pages/index'//首页
import Product from '@pages/goods/Product'//产品列表
import ProductDetail from '@pages/goods/ProductDetail'//产品详情
import CommonBlock from '@pages/main'
import Login from '@pages/login/Login'//登录
import Register from '@pages/login/register'//注册
import OrderConfirm from '@pages/order/OrderConfirm'//核对订单
import OrderDetail from '@pages/order/OrderDetail'//订单详情
import OrderList from '@pages/order/OrderList'//订单列表
import OrderCart from '@pages/order/OrderCart'//购物车
import AgentBrand from '@pages/agentBrand/index' //代理品牌
import AboutOur from '@pages/aboutOur/index' //关于我们
import newsCenter from '@pages/newsCenter/index' //新闻中心
import details from '@pages/newsCenter/details' //新闻中心

Vue.use(Router)
Vue.use(ElementUI, { size: 'small' })

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/pc/index'
    },
    {
      path: '/login',
      name: '登录/注册',
      component: Login,
      meta: {
        title: '登录/注册'
      }
    },
    {
      path: '/pc',
      component: CommonBlock,
      children: [{
        path: '/pc/index',
        name: '首页',
        component: IndexPage,
        meta: {
          title: '首页'
        }
      },
      {
        path: '/pc/product',
        name: '产品列表',
        component: Product,
        meta: {
          title: '产品列表'
        }
      },
      {
        path: '/pc/product-detail',
        name: '产品详情',
        component: ProductDetail,
        meta: {
          title: '产品详情'
        }
      },
      {
        path: '/pc/register',
        name: '注册',
        component: Register,
        meta: {
          title: '注册'
        }
      },
      {
        path: '/pc/order-confirm',
        name: '核对订单',
        component: OrderConfirm,
        meta: {
          title: '核对订单'
        }
      },
      {
        path: '/pc/order-detail',
        name: '订单详情',
        component: OrderDetail,
        meta: {
          title: '订单详情'
        }
      },
      {
        path: '/pc/order-cart',
        name: '购物车',
        component: OrderCart,
        meta: {
          title: '购物车'
        }
      },
      {
        path: '/pc/order-list',
        name: '订单列表',
        component: OrderList,
        meta: {
          title: '订单列表'
        }
      },
      {
        path: '/pc/agent-brand',
        name: '代理品牌',
        component: AgentBrand,
        meta: {
          title: '代理品牌'
        }
      },
      {
        path: '/pc/about-our',
        name: '关于我们',
        component: AboutOur,
        meta: {
          title: '关于我们'
        }
      },
      {
        path: '/pc/news-center',
        name: '新闻中心',
        component: newsCenter,
        meta: {
          title: '新闻中心'
        }
      },
      {
        path: '/pc/news-details',
        name: '新闻详情',
        component: details,
        meta: {
          title: '新闻详情'
        }
      }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  // console.log("to==="+JSON.stringify(to));
  if (to.meta.title) {
    next()
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js